import { useQuery, useMutation } from '@tanstack/react-query';
import { queryClient } from '@/config/reactQuery';
import { QUERY_KEYS } from '../../queryKeys';
import { shippingPlan } from '../ShippingPlan';

export const useShippingPlan = () =>
  useQuery({
    queryKey: [QUERY_KEYS.shippingPlan],
    queryFn: async () => (await shippingPlan.getShippingPlan()).data,
  });

export const useUploadShippingPlan = () =>
  useMutation({
    mutationFn: shippingPlan.uploadShippingPlan,
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.shippingPlan] }),
  });

export const useDeleteShippingPlan = () =>
  useMutation({
    mutationFn: shippingPlan.deleteShippingPlan,
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.shippingPlan] }),
  });
